import { useTranslation } from 'react-i18next';

export default function ComparisonSection() {
  const { t } = useTranslation();

  const rows = [
    { factor: t('comparison_product'), check: t('comparison_product_info') },
    { factor: t('comparison_price'), check: t('comparison_price_info') },
    { factor: t('comparison_weight'), check: t('comparison_weight_info') },
    { factor: t('comparison_shipping'), check: t('comparison_shipping_info') },
    { factor: t('comparison_qc'), check: t('comparison_qc_info') },
    { factor: t('comparison_link'), check: t('comparison_link_info') },
    { factor: t('comparison_policy'), check: t('comparison_policy_info') },
  ];

  return (
    <section className="py-12 md:py-16 bg-stone-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-stone-800">
            {t('comparison_h2')}
          </h2>
        </div>

        <div className="max-w-3xl mx-auto overflow-hidden rounded-xl border border-stone-200 bg-white">
          <div className="grid grid-cols-2">
            <div className="px-4 py-3 md:px-6 md:py-4 bg-stone-100 text-xs md:text-sm font-semibold text-stone-700 uppercase tracking-wider">
              {t('comparison_factor')}
            </div>
            <div className="px-4 py-3 md:px-6 md:py-4 bg-stone-100 text-xs md:text-sm font-semibold text-stone-700 uppercase tracking-wider">
              {t('comparison_check')}
            </div>
          </div>
          {rows.map((row, idx) => (
            <div
              key={row.factor}
              className={`grid grid-cols-2 ${idx % 2 === 0 ? 'bg-white' : 'bg-stone-50/50'}`}
            >
              <div className="px-4 py-3 md:px-6 md:py-4 text-sm font-medium text-stone-800 border-r border-stone-100">
                {row.factor}
              </div>
              <div className="px-4 py-3 md:px-6 md:py-4 text-sm text-stone-600">
                {row.check}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}